// LogisticIntegration.js (Refactored)
import React, { Component } from "react";
import { initialIntegrationsData } from "./integartionHelper";
import Input from "../../Controls/Input";
import {
  Section,
  SectionHeader,
  Grid,
  IntegrationCard,
  Button,
  FormField,
  LoadingSpinner,
} from "./DynamicIntegrationLayout";

const logisticIcons = {
  shiprocket: "🚚",
};

class LogisticIntegration extends Component {
  constructor(props) {
    super(props);

    const availableProviders = initialIntegrationsData.logistic.providers || [];

    this.state = {
      availableProviders: availableProviders,
      providersState: availableProviders.map(function(p) {
        return {
          ...p,
          email: "",
          password: "",
          deliveryType: "",
          category: "",
          isActive: false,
        };
      }),
      loading: true,
      savingIndex: null,
    };
    
    this.getIcon = this.getIcon.bind(this);
    this.fetchProviders = this.fetchProviders.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleToggleActive = this.handleToggleActive.bind(this);
    this.handleConfigureClick = this.handleConfigureClick.bind(this);
    this.renderFormFields = this.renderFormFields.bind(this);
  }

  getIcon(name) {
    if (logisticIcons.hasOwnProperty(name)) {
      return logisticIcons[name];
    }
    return "📦";
  }

  componentDidMount() {
    this.fetchProviders();
  }

  async fetchProviders() {
    try {
      this.setState({ loading: true });
      const response = await this.props.getLogisticProvider();

      if (response && response.code === "0") {
        const savedProviders = response.data || [];

        const updatedProviders = this.state.availableProviders.map(function(provider) {
          let saved = null;
          for (var i = 0; i < savedProviders.length; i++) {
            if (savedProviders[i].provider === provider.name) {
              saved = savedProviders[i];
              break;
            }
          }
          
          return {
            ...provider,
            email: (saved && saved.email) || "",
            password: (saved && saved.password) || "",
            deliveryType: (saved && saved.deliveryType) || "",
            isActive: (saved && saved.isActive) || false,
            category: (saved && saved.category) || "",
          };
        });

        this.setState({ providersState: updatedProviders });
      }
    } catch (error) {
      console.error(error);
      var errorMessage = "Failed to load providers";
      if (error && error.message) {
        errorMessage = error.message;
      }
      this.props.getToastr(errorMessage);
    } finally {
      this.setState({ loading: false });
    }
  }

  handleInputChange(index, field, value) {
    const updated = this.state.providersState.slice();
    updated[index][field] = value;
    this.setState({ providersState: updated });
  }

  handleToggleActive(index) {
    const isTurningOn = !this.state.providersState[index].isActive;
    const updated = this.state.providersState.map(function(p, i) {
      return {
        ...p,
        isActive: isTurningOn ? i === index : false,
      };
    });
    this.setState({ providersState: updated });
  }

  async handleConfigureClick(provider, index) {
    if (!provider) {
      this.props.getToastr("Provider data missing");
      return;
    }

    try {
      this.setState({ savingIndex: index });
      const response = await this.props.saveLogisticProvider(
        provider.name,
        provider.email,
        provider.password,
        provider.isActive,
        provider.deliveryType,
        null,
        provider.category
      );

      if (response && response.code === "0") {
        var successMessage = response.message || "Provider saved successfully";
        this.props.getToastr(successMessage);
      } else {
        var errorMessage = "Failed to save";
        if (response && response.message) {
          errorMessage = response.message;
        }
        this.props.getToastr(errorMessage);
      }
    } catch (error) {
      console.error(error);
      var errorMsg = "Failed to save";
      if (error && error.message) {
        errorMsg = error.message;
      }
      this.props.getToastr(errorMsg);
    } finally {
      this.setState({ savingIndex: null });
    }
  }

  renderFormFields(provider, index) {
    return (
      <div>
        <FormField label="Email">
          <Input
            type="text"
            value={provider.email}
            onChange={function(value) {
              this.handleInputChange(index, "email", value);
            }.bind(this)}
            placeholder="Enter provider email"
          />
        </FormField>

        <FormField label="Password">
          <Input
            type="password"
            value={provider.password}
            onChange={function(value) {
              this.handleInputChange(index, "password", value);
            }.bind(this)}
            placeholder="Enter provider password"
          />
        </FormField>

        <FormField label="Delivery Type">
          <Input
            type="select"
            value={provider.deliveryType}
            onChange={function(value) {
              this.handleInputChange(index, "deliveryType", value);
            }.bind(this)}
          >
            <option value="">Select delivery type</option>
            <option value="same_city">Same City Delivery</option>
            <option value="outside_city">Outside City Delivery</option>
          </Input>
        </FormField>

        <FormField label="Category">
          <Input
            type="select"
            value={provider.category}
            onChange={function(value) {
              this.handleInputChange(index, "category", value);
            }.bind(this)}
          >
            <option value="">Select category</option>
            <option value="Electronics">Electronics</option>
            <option value="Clothes">Clothes</option>
            <option value="Medicines">Medicines</option>
            <option value="Food">Food</option>
            <option value="Documents">Documents</option>
            <option value="Groceries">Groceries</option>
            <option value="Others">Others</option>
          </Input>
        </FormField>
      </div>
    );
  }

  render() {
    const { providersState, loading, savingIndex } = this.state;

    if (loading) {
      return React.createElement(LoadingSpinner, null);
    }

    return React.createElement(
      Section,
      null,
      React.createElement(SectionHeader, { title: initialIntegrationsData.logistic.title }),
      React.createElement(
        Grid,
        { minWidth: "100%", columns: 1 },
        providersState.map(function(provider, index) {
          return React.createElement(
            IntegrationCard,
            {
              key: provider.name,
              icon: this.getIcon(provider.name),
              title: provider.name,
              isActive: provider.isActive,
              onToggleActive: function() {
                this.handleToggleActive(index);
              }.bind(this),
              showToggle: true,
              actions: [
                React.createElement(
                  Button,
                  {
                    key: "save",
                    onClick: function() {
                      this.handleConfigureClick(provider, index);
                    }.bind(this),
                    disabled: savingIndex === index,
                    icon: savingIndex === index ? "⏳" : "💾"
                  },
                  savingIndex === index ? "Saving..." : "Save Changes"
                )
              ]
            },
            this.renderFormFields(provider, index)
          );
        }.bind(this))
      )
    );
  }
}

export default LogisticIntegration;